import { EkkoSoftDataType, EkkoSoftItem } from "@/core/interfaces"
import { storageHttpService } from "../storage-http.service"
import { BaseSensorService } from "./base-sensor.service"

/**
 *
 */
export class EkkoSoftSensorService
extends BaseSensorService<EkkoSoftItem, EkkoSoftDataType>
{
    protected dataTypeFilter(datatype: EkkoSoftDataType[""]) {
        return !!datatype.label.match(/power|cooling/i)
    }

    protected async getSiteSensorInformationRaw() {
        return storageHttpService.ekkoSoftSensorInformation(this.siteId)
    }
}